import { useCallback, useMemo } from 'react'
import { useSelector } from 'react-redux'
import { useParams } from 'react-router'

import { googleRightUploadAdDataSelector } from '../../../../../../../../modules/selectors/rights'

// there can be two cases of asset group create form:
// 1) simple usage on campaign summary page
// 2) usage inside multi-form on digital right summary page
// in the second case, we store newly created campaign inside separate redux store
export default function useCampaignDetails() {
  const { campaign: rightUploadAdCampaignData } = useSelector(googleRightUploadAdDataSelector)
  const { campaign_id: campaignId } = useParams()

  const { id: rightUploadAdCampaignId } = rightUploadAdCampaignData

  // if has data from right upload ad data selector, use its campaign data
  const isRightUploadAd = !!rightUploadAdCampaignId

  const getRegularCampaignData = useCallback(() => {
    return {
      campaignId
    }
  }, [campaignId])

  const getRightUploadAdCampaignData = useCallback(() => {
    return {
      campaignId: rightUploadAdCampaignId
    }
  }, [rightUploadAdCampaignId])

  return useMemo(
    () => (isRightUploadAd ? getRightUploadAdCampaignData() : getRegularCampaignData()),
    [isRightUploadAd, getRightUploadAdCampaignData, getRegularCampaignData]
  )
}
